<template>
  <div class="pages">
    <div class="top-tab">
      <van-popup v-model="detailShow" get-container="body" :style="{ height: '85%', width: '90%' }" :closeable="true">
        <div class="">
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            详情
          </div>
          <van-cell-group class="plr20">
            <van-cell title="气瓶编号" :value="detail.bottleId || '-'" />
            <van-cell title="登记单位" :value="detail.ownerDeptName || '-'" />
            <van-cell title="制造单位" :value="detail.makerDept || '-'" />
            <van-cell title="出厂编号" :value="detail.leaveFactoryNo || '-'" />
            <van-cell title="自有编号" :value="detail.ownerNo || '-'" />
            <van-cell title="制造年月" :value="detail.makeDate || '-'" />
            <van-cell title="末检年月" :value="detail.lastCheckDate || '-'" />
            <van-cell title="下检年月" :value="detail.nextCheckDate || '-'" />
            <van-cell title="报废年月" :value="detail.scrapDate || '-'" />
            <van-cell title="气瓶种类" :value="detail.bottleType || '-'" />
            <van-cell title="充装介质" :value="detail.gasTypeName || '-'" />
            <van-cell title="气瓶规格" :value="detail.bottleModel || '-'" />
          </van-cell-group>

          <div class="tc ptb10">
            <van-button type="danger" class="tc" @click="detailShow = false">关闭</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="show" get-container="body" :style="{ height: '85%', width: '96%' }" :closeable="true">
        <div class="">
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            列表
          </div>
          <div class="itme-wrapper" v-if="showbottleList.length">
            <div v-for="(item, index) in showbottleList" :key="index" style="padding: 0 0 10px; position: relative">
              <div class="items">
                <span class="item-name">登记单位：</span>
                <span class="item-value">{{ item.ownerDeptName || '-' }}</span>
              </div>
              <div class="items">
                <span class="item-name">气瓶编号：</span>
                <span class="item-value">{{ item.bottleId || '-' }}</span>
              </div>
              <div class="items">
                <span class="item-name">填充介质：</span>
                <span class="item-value">{{ item.gasTypeName || '-' }}</span>
              </div>
              <div class="items">
                <span class="item-name">入库时间：</span>
                <span class="item-value">{{ item.incomingTime || '-' }}</span>
              </div>

            </div>
          </div>
          <div class="tc ptb10">
            <van-button type="danger" class="tc" @click="show = false">关闭</van-button>
          </div>
        </div>
      </van-popup>
      <van-tabs v-model="active" color="#4597ff" sticky @click="initContent">
        <van-tab title="领用申请">
          <van-form ref="appForm" @submit="onSubmit" @failed="failed" validate-trigger="onSubmit" label-align="center"
            :scroll-to-error="true" :validate-first="true">           
        <van-field :required="true" :rules="[{ required: true, message: '' }]" v-model="appForm.sysDeptName" is-link readonly label="领用部门" placeholder="请选择领用部门"
					@click="getSysDepart" />
				<van-popup v-model="showSysDept" round position="bottom">
					<van-cascader v-model="cascaderValue" title="请选择领用部门" :options="sysDeptsOptions" @close="showSysDept = false"
						@change="onSysDeptChange" @finish="onSysDeptFinish" />
				</van-popup>
            <van-field readonly clickable name="picker" v-model="appForm.gasTypeName" label="充装介质"
              placeholder="点击选择充装介质" :required="true" @click="openPicker1('2')"
              :rules="[{ required: true, message: '' }]" />
            <van-field type="number" label="领用个数" v-model="appForm.borrowCount" placeholder="请输入领用个数" :required="true"
              :rules="[{ required: true, message: '' }]" />
            <van-field type="string" label="备注" v-model="appForm.remark" placeholder="选填" :required="false"
              :rules="[{ required: false, message: '' }]" />
            <div class="flex alcenter between">
              <van-field readonly class="flex1 saomabe" v-model="appForm.auditerName" @click="openPicker1('4')"
                label="审核人员" placeholder="请选择审核人员" :required="true" :rules="[{ required: true, message: '' }]" />
              <div class="saoma" @click="scanQRcode">扫码领用</div>
            </div>

            <van-popup v-model="showPicker" round position="bottom" get-container="#app">
              <van-picker title="请选择" item-height="7vh" show-toolbar :columns="columns" @confirm="pickerConfirm"
                @cancel="pickerCancel" />
            </van-popup>
            <div class="colors">
              <span>注：一次领用只能申请一种气体类型 已领用：{{ appForm.bottleList.length }}, 剩余可领用：{{ appForm.borrowCount - appForm.bottleList.length }}</span>
            </div>
            <div class="itme-wrapper" v-if="appForm.bottleList.length">
              <div v-for="(item, index) in appForm.bottleList" :key="index"
                style="padding: 0 0 10px; position: relative">
                <div class="items">
                  <span class="item-name">气瓶编号：</span>
                  <span class="item-value">{{ item.bottleId }}</span>
                </div>
                <div class="items">
                  <span class="item-name">末检年月：</span>
                  <span class="item-value">{{ item.lastCheckDate }}</span>
                </div>
                <div class="items">
                  <span class="item-name">下检年月：</span>
                  <span class="item-value">{{ item.nextCheckDate }}</span>
                </div>
                <div class="items">
                  <span class="item-name">报废年月：</span>
                  <span class="item-value">{{ item.scrapDate }}</span>
                </div>
                <van-button type="danger" size="small" class="delete-btn" native-type="button"
                  @click="deleteItem(index, item)">删除</van-button>
              </div>
            </div>

            <div style="position: fixed; bottom: 0" class="flex w100">
              <van-button class="flex1 w47" style="border-right: 3px solid #fff" @click="reset" square block type="info"
                native-type="button">重置</van-button>
              <van-button class="flex1 w50" square block type="info" native-type="submit">提交审核</van-button>
            </div>
          </van-form>
        </van-tab>
        <van-tab title="领用历史">
          <div>
            <van-pull-refresh class="bggrey" v-model="isLoading" @refresh="onRefresh">
              <div class="history">
                <van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
                  <van-cell v-for="(item, index) in historyList" :key="index" style="margin-top: 20px; padding: 0">
                    <div class="main">
                      <div class="history-left">
                        <div class="history-item">
                          <span>领用部门：</span>
                          <span>{{ item.sysDeptName }}</span>
                        </div>
                        <div class="history-item">
                          <span>填充介质：</span>
                          <span>{{ item.gasTypeName }}</span>
                        </div>
                        <div class="history-item">
                          <span>领用个数：</span>
                          <span>{{ item.borrowCount }}</span>
                        </div>
                        <div class="history-item">
                          <span>领用时间：</span>
                          <span>{{ item.borrowDate }}</span>
                        </div>
                        <div class="history-item">
                          <span>审核人：</span>
                          <span>{{ item.auditerName }}</span>
                        </div>
                        <div class="history-item">
                          <span>审核人：</span>
                          <span>{{ item.remark }}</span>
                        </div>
                      </div>
                      <div class="hisotry-right">
                        <img v-if="item.auditStatus == 0" src="@/assets/visitor/daishenhe.png" alt="" /> 
                        <img v-if="item.auditStatus == 1" src="@/assets/visitor/agree.png" alt="" />                        
                        <img v-if="item.auditStatus == 2" src="@/assets/visitor/reject.png"	alt="" />
                      </div>
                      <van-button plain type="primary" size="small" class="userBtn" @click="getDetail(item)">列表
                      </van-button>
                      <van-button v-if="item.auditStatus == 2" plain type="primary" size="small" class="userBtn1"
											@click="editBorrow(item)">编辑</van-button>
                    </div>
                  </van-cell>
                </van-list>
              </div>
            </van-pull-refresh>
          </div>
        </van-tab>
        <van-tab title="当前未还">
          <div>
            <van-pull-refresh class="bggrey" v-model="isLoading" @refresh="onRefresh1">
              <div class="history">
                <van-list v-model="loading" :finished="nofinishedBottom" finished-text="没有更多了">
                  <van-cell v-for="(item, index) in noReturnList" :key="index" style="margin-top: 20px; padding: 0">
                    <div class="main">
                      <div class="history-left">

                        <div class="history-item">
                          <span>领用部门：</span>
                          <span>{{ item.sysDeptName }}</span>
                        </div>
                        <div class="history-item">
                          <span>气瓶编号：</span>
                          <span>{{ item.bottleId }}</span>
                        </div>
                        <div class="history-item">
                          <span>填充介质：</span>
                          <span>{{ item.gasTypeName }}</span>
                        </div>
                        <div class="history-item">
                          <span>领用时间：</span>
                          <span>{{ item.borrowDate }}</span>
                        </div>
                        <div class="history-item">
                          <span>领用人：</span>
                          <span>{{ item.borrowerName }}</span>
                        </div>
                      </div>
                      <van-button plain type="primary" size="small" class="userBtn1" @click="getAirDetail(item)">详情
                      </van-button>
                    </div>
                  </van-cell>
                </van-list>
              </div>
            </van-pull-refresh>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import {
  //bottleInfoQueryAll,//所有登记单位
  getDepartments,//获取部门列表
  //querySysDeptInfo,//查询部门信息
  addApplyRecord,//提交领用
  queryGasType,//充装介质列表
  queryIncomingAuditor,//审核中列表
  queryBorrowHistory,//领用历史
  queryBorrowDetail,//领用历史详情
  queryBorrowBottle,//根据气瓶条码查询领用气体详情
  queryBorrowBottleByQrcode,//根据气瓶二维码查询领用气体详情
  getJsApi,//扫码配置
  queryNoReturnBottleList,//未归还的领用记录
} from "@/apis/api";
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      active: 0,
      showPicker: false,
      columns: [],
      isLoading: false,
      loading: false,
      finishedBottom: false,
      show: false,
      detailShow: false,
      detail: {},
      historyList: [],
      pageSize: 1,
      pageNo: 10,
      picker_car: "",
      showList: [],
      showbottleList: [],
      sysDeptsOptions:[],//下拉选择的部门
      cascaderValue:"",
      showSysDept:false,
      appForm: {
        sysDept:"",//登记部门
        sysDeptName: "", //登记部门名称
        gasType: "", //气体类型id
        gasTypeName: "", //气体类型名称
        auditer: "", // 审核人Id ,
        auditerName: "", // 审核人姓名 ,
        borrowCount: "", //领用个数 ,
        remark: "", //备注 ,
        bottleList: [],
      },
      noReturnList: [],
      nofinishedBottom: false,
    };
  },
  mounted() {
    document.title = "气瓶领用";
    this.getSystemConfig();
  },
  methods: {
    getAirDetail(item) {
      this.detailShow = true;
      this.detail = item;
    },
    getDetail(item) {
      this.show = true;
      this.getDetailList(item.id);
    },
    editBorrow(item) {
      this.appForm.sysDept = item.sysDept;
      this.appForm.sysDeptName = item.sysDeptName;
      this.appForm.gasType = item.gasType;
      this.appForm.gasTypeName = item.gasTypeName;
      this.appForm.auditer = item.auditer;
      this.appForm.auditerName = item.auditerName;
      this.appForm.borrowCount = item.borrowCount;
      this.appForm.remark = item.remark;
      //重新查询当前预约的气瓶列表，避免列表中气瓶已经被领用过
      queryBorrowDetail({
        applyforId: item.id
      }).then(res => {
        if (res.code == 200) {
          //过滤掉res.reslut中已经领用的气瓶
          this.appForm.bottleList = res.result.filter((item) => {
            return item.stockStatus == 1;
          });          
        } else {
          this.$toast(res.message);
        }
      })
      this.active = 0;
    },
    //记录详情列表
    getDetailList(id) {
      queryBorrowDetail({
        applyforId: id
      }).then(res => {
        if (res.code == 200) {
          this.showbottleList = res.result;
        } else {
          this.$toast(res.message);
        }
      })
    },
    failed() { },
    // 打开picker弹窗
    openPicker1(code) {
      if (this.picker_car !== code) this.getSysCategory(code);
      this.picker_car = code;
      this.showPicker = true;
    },
    // 选择picker弹窗确定
    pickerConfirm(e) {
      
      if (this.picker_car === "2") {
        this.appForm.gasType = e.id;
        this.appForm.gasTypeName = e.text;
        this.appForm.bottleList = this.appForm.bottleList.filter((item) => {
          item.gasType == this.appForm.gasType;
        })
      } else if (this.picker_car === "4") {
        this.appForm.auditer = e.id;
        this.appForm.auditerName = e.text;
      }
      this.showPicker = false;
    },
    // 选择picker弹窗取消
    pickerCancel() {
      this.showPicker = false;
    },
    //查询picker弹窗列表
    getSysCategory(code) {
      let api = "";
    
      if (code === "2") {
        api = queryGasType;
      } else if (code === "4") {
        api = queryIncomingAuditor;
      }
      this.columns = [];
      api().then((res) => {
        if (res.code == 200) {
          
          if (code === "4") {
            if (res.result.length) {
              res.result.forEach((i, v) => {
                i.id = i.uid;
                i.text = i.personName;
              });
            }
          } else {
            if (res.result.length) {
              res.result.forEach((i, v) => {
                i.text = i.name;
              });
            }
          }
          this.columns = res.result;
        } else {
          this.$toast(res.message);
        }
      });
    },
    getSysDepart() {
				this.showSysDept = true;
				getDepartments().then((res) => {
					console.log(res);
					this.sysDeptsOptions = res.result.map((item) => {
						item.text = item.departName;
						item.value = item.id;
						if( item.departList.length>0){
							item.children = item.departList;
							item.children.forEach(iitem => {
								iitem.text = iitem.departName
								iitem.value = iitem.id;
							})
						}
						
						return item;
					});
				});
			},

      onSysDeptChange({
				value
			}) {

			},
			onSysDeptFinish({
				selectedOptions
			}) {
				this.showSysDept = false;
				this.appForm.sysDeptName = selectedOptions.map((option) => option.text).join("/");				
				this.appForm.sysDept = selectedOptions.pop().value;
        console.info("选择的部门："+this.appForm.sysDeptName+",部门id:"+this.appForm.sysDept);
			},

    // 提交领用申请
    onSubmit() {
      if (this.appForm.sysDept == "") {
        this.$toast("请选择领用单位");
        return;
      }
      if (this.appForm.gasType == "") {
        this.$toast("请选择充装介质");
        return;
      }
      if (this.appForm.auditer == "") {
        this.$toast("请选择审核人");
        return;
      }
      if (this.appForm.bottleList.length == 0) {
        this.$toast("请扫码添加气瓶");
      }
      if (this.appForm.borrowCount != this.appForm.bottleList.length) {
        this.$toast("输入的领用个数和实际领用的气瓶数不同");
        return;
      }
      console.log(this.appForm);
      addApplyRecord(this.appForm).then((res) => {
        if (res.code == 200) {
          this.$toast(res.message || "提交成功");
          this.reset();
        } else {
          this.$toast(res.message || "提交失败");
        }
      });
    },
    // 重置
    reset() {
      this.appForm = {
        sysDept: "", //登记单位id
        sysDeptName: "", //登记单位名称
        gasType: "", //气体类型id
        gasTypeName: "", //气体类型名称
        auditer: "", // 审核人Id ,
        auditerName: "", // 审核人姓名 ,
        borrowCount: "", //气瓶总数 ,
        remark: "", //备注 ,
        bottleList: [],
      };
    },
   
    // 获取历史
    getHistoryList() {
      this.onRefresh(1);
    },
    //历史列表
    onRefresh(index) {
      this.pageNo = 1;
      this.pageSize = 10;
      this.isLoading = true;
      queryBorrowHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          if (index != 1) {
            Toast("刷新成功");
          }
          this.historyList = res.result.records;
          this.total = res.result.total;
          if (this.historyList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    // 历史列表加载更多
    onLoad() {
      console.log("加载更多");
      if (this.isLoading) return;
      this.pageNo++;
      queryBorrowHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          this.historyList = this.historyList.concat(res.result.records);
          if (this.historyList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    //未归还列表
    onRefresh1(index) {
      this.isLoading = true;
      queryNoReturnBottleList().then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          if (index != 1) {
            Toast("刷新成功");
          }
          this.noReturnList = res.result;
          this.nofinishedBottom = true;
        } else {
          this.nofinishedBottom = true;
        }
      });
    },
    // tab点击
    initContent(value) {
      this.active = value;
      if (value == 0) {
        // 刷新页面
      } else if (value == 1) {
        this.pageSize = 10;
        this.pageNo = 1;
        this.getHistoryList();
      } else {
        this.onRefresh1(1);
      }
    },
    //删除气瓶
    deleteItem(index, item) {
      Dialog.confirm({
        title: "提示",
        message: "确认删除该气瓶吗？",
      }).then(() => {
        if (this.appForm.bottleList.length >= 1) {
          this.appForm.bottleList.splice(index, 1);
        }
      }).catch(() => { });
    },
    // 扫码配置
    getSystemConfig() {
      getJsApi({ curUrl: encodeURI(location.href.split("#")[0]) })
        .then((res) => {
          if (res.code == 200) {
            let configs = res.result;
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: configs.appId, // 必填，公众号的唯一标识
              timestamp: configs.timestamp, // 必填，生成签名的时间戳
              nonceStr: configs.nonceStr, // 必填，生成签名的随机串
              signature: configs.signature, // 必填，签名
              jsApiList: ["scanQRCode"], // 必填，需要使用的JS接口列表
            });
            wx.ready((res) => {
              console.log("配置完成，扫码前准备完成");
            });
            wx.error(function (res) {
              console.log("出错了：" + res.errMsg);
            });
          } else {
            this.$toast(res.message);
          }
        })
        .catch((err) => { });
    },
    //扫码
    scanQRcode: function () {
      if(this.appForm.borrowCount <= 0)
      {
        this.$toast("请先设置领用数量");
        return
      }
      if(this.appForm.bottleList.length == this.appForm.borrowCount)   //入库数量等于气瓶总数
          {
            this.$toast("当前入库数量已达到最大值，请提交");
            return
          }
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      if (!isWeixin) {
        alert("请用微信打开连接，才可使用扫一扫");
      }
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        //scanType: ["barCode"], // 条形码
        scanType: ["qrCode"], // 二维码
        success: (res) => {
          console.log(res);
          try {
            //const json = {"resultStr": "CODE 128,0110125566", "errMsg": "scanQRCode:ok"};
            //const json = JSON.parse(res.resultStr);
            if (res.resultStr.length > 0) {
              //气瓶条码
              // const resultArray = res.resultStr.split(",");
              // console.log(resultArray);
              // this.getGasDetail(resultArray[1]);
              //气瓶二维码
              this.getGasDetail(res.resultStr);
            }
          } catch {
            alert(res.resultStr);
          }
        },
        fail: (err) => {
          console.log(err);
        },
      });
    },
    // 领用气体详情
    getGasDetail(resultStr) {
      //改为根据二维码来查询气瓶信息
      //queryBorrowBottle      
      queryBorrowBottleByQrcode({
        //bottleId: resultStr,
        qrcode: resultStr,
      }).then((res) => {
        if (res.code == 200) {
          let result = res.result;          
          // if (this.appForm.ownerDept && result.ownerDept !== this.appForm.ownerDept) {
          //    this.$toast(`登记单位不符合，当前扫码气瓶登记单位为${result.ownerDeptName},请重新扫码`);
          //    return;
          // }
          if (this.appForm.gasType && result.gasType !== this.appForm.gasType) {
             this.$toast(`填充介质不符合,当前扫码气瓶填充介质为${result.gasTypeName},请重新扫码`);
             return;
          }
          //判断当前气瓶是否在列表中       
          for (let i = 0; i < this.appForm.bottleList.length; i++) {
            if (this.appForm.bottleList[i].bottleId === result.bottleId) {
              this.$toast(`该气瓶已存在，请勿重复添加`);
              return;
            }
          }
          this.appForm.bottleList.splice(0,0,res.result);
          this.$set(this.appForm.bottleList, this.appForm.bottleList);
          if(this.appForm.bottleList.length == this.appForm.borrowCount)   //领用数量等于气瓶总数
          {
            this.$toast("当前领用数量已达到设定值，请提交");
          }
        } else {
          this.$toast(res.message);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.pages {
  background: #f3f3f3;
  // min-height: 100vh;
  min-height: calc(100vh - 180px);
  padding-bottom: 7vh !important;
}

.nodata {
  text-align: center;
  margin-top: 100px;
  color: #999;
}

.saoma {
  background-color: #4597ff;
  color: #fff;
  height: 6.5vh;
  line-height: 6.5vh;
  text-align: center;
  width: 18vw;
}

.saomabe {
  height: 6.5vh !important;
}

.history {
  padding: 16px;
  min-height: calc(100vh - 230px);

  .main {
    padding: 12px 18px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .history-item {
      height: 56px;
      line-height: 56px;

      span {
        font-size: 28px;
        color: #333;
      }
    }
  }

  .userBtn {
    position: absolute;
    right: 20px;
    top: 25px;
    width: 94px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: none;
    border-radius: 5px;
    color: #55aa7f;
  }

  .userBtn1 {
    position: absolute;
    right: 20px;
    top: 90px;
    width: 94px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: none;
    border-radius: 5px;
    color: #55aa7f;
  }

  .hisotry-right {    
    img {
      width: 150px;
      height: 150px;
    }
  }

}

.delete-btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  height: 50px;
}


.itme-wrapper {
  padding: 16px;

  .items {
    height: 50px;
    background: #ccc;
    padding: 0 10px;
    line-height: 50px;
  }
}


.colors {
  color: #e80404;
  margin: 14px 0 0 40px;
}
</style>
